import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Unified_Logo_Black_White_Text.svg")